import { render, staticRenderFns } from "./ClientContact.vue?vue&type=template&id=02dd13b0&scoped=true&lang=pug&"
import script from "./ClientContact.vue?vue&type=script&lang=ts&"
export * from "./ClientContact.vue?vue&type=script&lang=ts&"
import style0 from "./ClientContact.vue?vue&type=style&index=0&id=02dd13b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd13b0",
  null
  
)

export default component.exports